import React from 'react';

const Hero = () => {
  return (
    <section className="min-h-screen bg-gradient-to-b from-[#FFE135] to-white flex flex-col items-center justify-center">
    {/* Banner Container */}
    <div className="w-full max-w-6xl mx-auto px-4 mb-8">
      <div className="relative w-full rounded-lg overflow-hidden shadow-xl">
        <img 
          src="/assets/images/adelaide-samba-encontro-2025-banner.png" 
          alt="Adelaide Samba Encontro 2025 Banner" 
          className="w-full h-auto"
        />
      </div>
    </div>
    
    {/* Original Hero Content */}
    <div className="text-center">
      <h1 className="text-6xl font-bold mb-4">Adelaide Samba Encontro 2025</h1>
      <p className="text-xl">Adelaide's Premier Samba Event</p>
    </div>
  </section>
  );
};

export default Hero;